export default {
  getDataFromServer: async ({ backEndService, company, bot }, content) => {
      const url = `${backEndService}/${company}/bots/${bot}/api/web`;

      if(content.body instanceof FormData == false) {
        content.body = JSON.stringify(content.body);
      }
      content.headers = content.headers ? content.headers : {};
      const headers = {'X-Talkr-Query': '1' };
      content.headers = { ...content.headers, ...headers };

      if(content.headers['Content-Type'] == undefined) {
        content.headers['Content-Type'] = 'application/json';
      }

      if(content.body instanceof FormData) {
        delete content.headers['Content-Type'];
      }

      try {
        const response = await fetch(url, content);

        return await response.json();
      } catch (error) {
        console.error('Erreur lors de la requête :', error);
        return {error : true, message : 'La requête a échoué'}
        //throw error;
      }
    },

    requestVariableForServer: async ({ backEndService, company, bot }, content) => {
      const url = `${backEndService}/${company}/bot/${bot}/instance/variable`;
      content.headers = { 'Content-Type': 'application/json' };
      content.body = JSON.stringify(content.body);

      try {
        const response = await fetch(url, content);
        if (!response.ok) {
          throw new Error('La requête a échoué');
        }
        return await response.json();
      } catch (error) {
        console.error('Erreur lors de la requête :', error);
        throw error;
      }
    }

}